import React, { useEffect, useState } from 'react';
import useCatalogoAvatares from '../hooks/useCatalogoAvatares';
import { corDoUsuario, iniciais, urlDoAvatar } from '../utils/avatarUsuario';
import { urlDoAvatarPersonalizado } from '../utils/avatarPersonalizado';
import '../styles/AvatarUsuario.css';

// Avatar de uma pessoa, igual em toda a plataforma (docs/avatares.md):
// - com avatar escolhido: a imagem do catálogo (caminho_arquivo do banco);
// - sem avatar, com avatar inativo ou se a imagem falhar: as iniciais sobre a
//   cor fixa da pessoa (corDoUsuario).
// O nome vai no alt (imagem) ou no aria-label (iniciais). `rotulo` troca o
// texto; `decorativo` some para o leitor de tela (quando o nome já está ao
// lado ou o botão em volta já tem rótulo).
//
// usuario: { id, nome, avatar_id, avatar_hash }. tamanho (px) é opcional: sem ele, o
// tamanho vem do CSS da classe passada em className (ex.: .tf-avatar).
const AvatarUsuario = ({
  usuario,
  tamanho,
  className = '',
  rotulo,
  title,
  decorativo = false,
  style,
}) => {
  const { porId } = useCatalogoAvatares();
  // Prioridade: personalizado (SVG gerado pelo backend, URL com o hash) >
  // avatar pronto do catálogo > iniciais.
  const personalizado = urlDoAvatarPersonalizado(usuario?.id, usuario?.avatar_hash);
  const avatar = !personalizado && usuario?.avatar_id ? porId.get(Number(usuario.avatar_id)) : null;
  const src = personalizado || (avatar ? urlDoAvatar(avatar.caminho_arquivo) : null);
  const [falhou, setFalhou] = useState(false);
  useEffect(() => { setFalhou(false); }, [src]);

  const nome = usuario?.nome || '';
  const texto = rotulo || nome;
  const medidas = tamanho
    ? { width: tamanho, height: tamanho, fontSize: Math.max(9, Math.round(tamanho * 0.4)) }
    : {};
  const classes = ['avatar-usuario', className].filter(Boolean);

  if (src && !falhou) {
    return (
      <span className={[...classes, 'com-imagem'].join(' ')} style={{ ...medidas, ...style }} title={title}>
        <img
          src={src}
          alt={decorativo ? '' : texto}
          loading="lazy"
          onError={() => setFalhou(true)}
          draggable={false}
        />
      </span>
    );
  }

  return (
    <span
      className={[...classes, 'com-iniciais'].join(' ')}
      style={{ ...medidas, backgroundColor: corDoUsuario(usuario?.id), ...style }}
      title={title}
      {...(decorativo ? { 'aria-hidden': true } : { role: 'img', 'aria-label': texto })}
    >
      <span aria-hidden="true">{iniciais(nome)}</span>
    </span>
  );
};

export default AvatarUsuario;
